import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ConnectionService } from 'ng-connection-service';
import { ToastrService } from 'ngx-toastr';
import { US_ORIGIN } from '../constants';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  isConnected: any = true;

  reportData = new Subject<any>();
  currentPlayingAudio = new Subject<any>();
  currentPlayingVideo = new Subject<any>();
  currentPlayingAudioTime = new Subject<any>();
  currentPlayingVideoTime = new Subject<any>();
  videoEnded = new Subject<any>();
  private refreshSubject = new Subject<void>();
  refresh$ = this.refreshSubject.asObservable();
  private controller?: AbortController;

  constructor(private http: HttpClient, private connectionService: ConnectionService, private toastr: ToastrService) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
    });
  }

  getUrl(url): any {
    if (this.isConnected) {
      let apiUrl = url;
      return this.http.get(apiUrl);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  getRequest(url): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV + url;
      return this.http.get(apiUrl);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  getRequestWithParams(url, data): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV + url;
      return this.http.get(apiUrl, { params: data });
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postRequest(url, data): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV + url;
      console.log('::::::::>>>>>>>>', url)
      if (url == 'channel/home' || url == 'getUserByEmail') {
        apiUrl = environment.VENDOR_API_URL + url
      }
      return this.http.post(apiUrl, data);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postCustomRequest(url, data, reqHeaders): any {
    if (this.isConnected) {
      const headers = new HttpHeaders(reqHeaders);
      let apiUrl = environment.API_URL_TV + url;
      return this.http.post(apiUrl, data, { headers: headers, responseType: 'blob' });
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postFormData(url, data) {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV + url;
      return this.http.post(apiUrl, data);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postWithQuery(url, data) {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV + url;
      return this.http.post(apiUrl, data);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postWithFile(url, data, files) {
    if (this.isConnected) {
      const formData: FormData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append(files[i].key, files[i].file);
      }
      for (const property in data) {
        if (data.hasOwnProperty(property)) {
          formData.append(property, data[property]);
        }
      }
      let apiUrl = environment.API_URL_TV + url;
      return this.http.post(apiUrl, formData);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  postWithFileLambda(url, data) {
    if (this.isConnected) {
      let apiUrl = environment.AWS_Cognito.apiBase + url;
      const headers = {
        'Content-Type': 'multipart/form-data',
        'Accept': 'application/json',
        'x-api-key': environment.AWS_Cognito.X_Api_Key
      }
      return this.http.post(apiUrl, data);
    } else {
      this.toastr.error("Please check network connection");
    }
  }
  putWithFileS3(url, files) {
    if (this.isConnected) {
      //console.log("files.type :: ",files.type); 
      const formData: FormData = new FormData();
      formData.append("file", files);
      let apiUrl = url;
      // return this.http.put(apiUrl, files).pipe(map(res => res));
      const headers = new HttpHeaders({ 'Content-Type': files.type });
      const req = new HttpRequest('PUT', apiUrl, formData, { headers: headers, reportProgress: true, });
      return this.http.request(req);
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  checkURLs(url) {
    let returnValue = false;
    US_ORIGIN.forEach(e => {
      if (url.indexOf(e) != -1)
        returnValue = true;
    });
    return returnValue;
  }

  getNFTJson(url) {
    console.log("URL in getNFTJSON ", url)
    const json = this.http.get('https://ipfs.io/ipfs/' + url);
    console.log("JSON in getNFT ", json)
    return json
  }
  postBaseRequest(url, data): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV_BASE + url;
      return this.http.post(apiUrl, data);
    } else {
      this.toastr.error("Please check network connection");
    }
  }
  pubnubpostBaseRequest(url, data): any {
    if (this.isConnected) {
      let apiUrl = url;
      return this.http.post(apiUrl, data).pipe(map(res => res));
    } else {
      this.toastr.error("Please check network connection");
    }
  }
  getBaseRequest(url, username?: string): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV_BASE + url;
      let headers = new HttpHeaders();
      if (username) {
        headers = headers.append("username", username);
      }
      const generatedUUID = uuidv4();
      headers = headers.append("requestId", generatedUUID);
      return this.http.get(apiUrl, { headers: headers }).pipe(map((res) => res));
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  uploadFileAWSS3(url, contentType, file): any {
    const headers = new HttpHeaders({ "Content-Type": contentType });
    const req = new HttpRequest("PUT", url, file, {
      headers: headers,
      reportProgress: true, //This is required for track upload process
    });
    return this.http.request(req);
  }

  postAgentStreamFetch(url: string, data: any, username?: string, authToken?: string): Observable<any> {
    return new Observable(observer => {
      this.controller = new AbortController();
      
      let headers = {
        'Accept': 'text/event-stream'
      }

      if (username) {
        headers['username'] = username;
      }

      if (authToken) {
        headers['Authorization'] = authToken;
      }

      const generatedUUID = uuidv4();
      headers['requestId'] = generatedUUID;

      let apiUrl = environment.API_URL_TV_BASE + url;

      fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: data,
        signal: this.controller.signal
      }).then(async (res) => {
        if (!res.ok || !res.body) {
          observer.error(`HTTP error ${res.status}`);
          return;
        }

        const reader = res.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          buffer += decoder.decode(value, { stream: true });
          const lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (const line of lines) {
            if (!line.trim()) continue;
            if (line.startsWith('data:')) {
              const chunk = line.replace(/^data:\s*/, '');
              if (chunk === '[DONE]') {
                observer.complete();
                return;
              }
              try {
                observer.next(JSON.parse(chunk));
              } catch {
                observer.next({ chunk });
              }
            }
          }
        }

        observer.complete();
      }).catch(err => {
        if (err.name === 'AbortError') {
          observer.complete();
        } else {
          observer.error(err);
        }
      });
    });
  }
  
  postBase1Request(url, data, username?: string,accessToken?:any): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV_BASE + url;
      let headers = new HttpHeaders();

      if (username) {
        headers = headers.append("username", username);
      }
      if(accessToken) {
        headers = headers.append("Authorization", accessToken);
      }
      const generatedUUID = uuidv4();
      headers = headers.append("requestId", generatedUUID);

      return this.http.post(apiUrl, data, { headers: headers }).pipe(map((res) => res));
    } else {
      this.toastr.error("Please check network connection");
    }
  }
  deleteBaseRequest(url: any, username?: any): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_TV_BASE + url;
      console.log("deleteBaseRequest", apiUrl);
      
      let headers = new HttpHeaders();
      if (username) {
        headers = headers.append("username", username);
      }
      const generatedUUID = uuidv4();
      headers = headers.append("requestId", generatedUUID);

      return this.http.delete(apiUrl, { headers: headers }).pipe(map((res) => res));
    } else {
      this.toastr.error("Please check network connection");
    }
  }
  triggerRefresh() {
    this.refreshSubject.next();
  }


    getUserInfoUsingOneLoginCode(code,authType:string): any {
    if (this.isConnected) {
      let apiUrl = environment.API_URL_CODE_EXCHANGE;
    return this.http.post(apiUrl, { code, authType });
    } else {
      this.toastr.error("Please check network connection");
    }
  }

  getOrgDetails(apiUrl:string): any {
    if (this.isConnected) {
    return this.http.get(apiUrl);
    } else {
      this.toastr.error("Please check network connection");
    }
  }
}


